import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/images/booking-mark-butler.jpg'


const _hoisted_1 = { class: "vue-tl-booking-mark-butler" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Heatshot of Mark Butler"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "meetings-iframe-container",
  "data-src": "https://meetings.hubspot.com/thought-leaders/chat-with-mark?embed=true"
}, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _component_WidgetContainerComponent = _resolveComponent("WidgetContainerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WidgetContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
        }, _hoisted_3),
        _withDirectives(_createVNode(_component_ModalComponent, {
          "hide-footer": true,
          onClose: _cache[1] || (_cache[1] = ($event: any) => {_ctx.open = false;})
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.open]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}